<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn icon :small="small" :loading="saving" :aria-label="label" v-on="on" @click.stop.prevent="toggle">
        <!-- no-gradient: sovelluksen gradient-icons-tyyli värjäisi tähden teemanväriseksi, jolloin suosikki ei erotu. -->
        <v-icon :small="small" :color="site.favorite ? 'amber darken-2' : 'grey'" class="no-gradient">
          {{ site.favorite ? 'mdi-star' : 'mdi-star-outline' }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
import siteApi from '@/api/site';

/**
 * Käyttäjän oman suosikkityömaan vaihtokytkin. Muuttaa annettua työmaaoliota suoraan (favorite-lippu), jolloin
 * sama olio päivittyy kaikissa listoissa, joissa se on. Tallennus optimistisesti; virheessä palautetaan.
 */
export default {
  name: 'SiteFavoriteButton',
  props: {
    site: {
      type: Object,
      required: true,
    },
    small: Boolean,
  },
  data() {
    return {
      saving: false,
    };
  },
  computed: {
    label() {
      return this.site.favorite ? this.$t('sites.remove_favorite') : this.$t('sites.add_favorite');
    },
  },
  methods: {
    async toggle() {
      if (this.saving) return;
      const favorite = !this.site.favorite;
      this.$set(this.site, 'favorite', favorite);
      this.saving = true;
      try {
        if (favorite) {
          await siteApi.setFavorite(this.site.id);
        } else {
          await siteApi.removeFavorite(this.site.id);
        }
      } catch (error) {
        console.error(error);
        this.$set(this.site, 'favorite', !favorite);
        this.$showErrorNotification(this.$t('errors.error_saving_favorite'));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
